/**
 * Returns the base URL for API requests.
 * - Web: empty string (relative URLs, same-origin)
 * - Native (Capacitor): the full backend URL from VITE_API_URL
 */
export function getApiBaseUrl(): string {
  return import.meta.env.VITE_API_URL || "";
}

/**
 * Returns the WebSocket URL for the sync endpoint.
 * - Web: derives from current location (existing behavior)
 * - Native: derives from VITE_API_URL
 */
export function getSyncWsUrl(): string {
  const baseUrl = getApiBaseUrl();
  if (!baseUrl) {
    const protocol = location.protocol === "https:" ? "wss:" : "ws:";
    return `${protocol}//${location.host}/api/sync`;
  }
  const url = new URL("/api/sync", baseUrl);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
}
